import { BoxProps } from '@mui/material';
import { useEffect, useState } from 'react';
import {
  Root,
  QuantityUpdateButton,
  QuantityUpdateIcon,
  QuantityContainer,
} from './QuantityCounterStyle';

const minLimit = 1;
const maxLimit = 99;

export interface QuantityCounterProps extends BoxProps {
  quantity: string | number;
  setQuantity: (count: number) => void;
}

export function QuantityCounter({ quantity, setQuantity, ...rest }: QuantityCounterProps) {
  const [value, setValue] = useState<string | number>(quantity);

  const decrementHandler = () => {
    if (typeof quantity === 'number' && quantity > minLimit) {
      setQuantity(quantity - 1);
    }
  };

  const incrementHandler = () => {
    if (typeof quantity === 'number' && quantity < maxLimit) {
      setQuantity(quantity + 1);
    }
  };

  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
  };

  const onBlurHandler = (event: React.FocusEvent<HTMLInputElement>) => {
    let value = parseInt(event.target.value);
    if (Number.isNaN(value)) {
      return;
    }
    if (value < minLimit) {
      value = minLimit;
    }
    if (value > maxLimit) {
      value = maxLimit;
    }
    setValue(value);
    setQuantity(value);
  };

  useEffect(() => {
    setValue(quantity ?? '');
  }, [quantity]);

  return (
    <Root {...rest}>
      <QuantityUpdateButton
        className='quantity-update-button decrement-button'
        onClick={decrementHandler}
      >
        <QuantityUpdateIcon>-</QuantityUpdateIcon>
      </QuantityUpdateButton>
      <QuantityContainer
        className='quantity-container'
        type='number'
        onChange={onChangeHandler}
        onBlur={onBlurHandler}
        value={value}
      />
      <QuantityUpdateButton
        className='quantity-update-button increment-button'
        onClick={incrementHandler}
      >
        <QuantityUpdateIcon>+</QuantityUpdateIcon>
      </QuantityUpdateButton>
    </Root>
  );
}
